import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=529587fc&scoped=true&"
import script from "./Table.vue?vue&type=script&lang=js&"
export * from "./Table.vue?vue&type=script&lang=js&"
import style1 from "./Table.vue?vue&type=style&index=1&id=529587fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529587fc",
  null
  
)

export default component.exports